<template>
	<div class="page-container">
		<div class="back_left" @click="$router.go(-1)" />
		<div class="headers">
			<h1 style="margin-top: 10px;">{{ title }}</h1>
		</div>
		<div class="imggw">
			<img width="150px" src="../images/user/11wh0-eeva3.png" alt="">
		</div>
		<div class="form-wrapper">
			<form class="card-form">
				<div class="form-title">{{ topText }}</div>
				<div class="form-money">金额：<span>{{ money }}元</span></div>
				<div class="confirm-text">
					<span>{{ text1 }}</span>
					<span style="margin-top: 10px;">{{ text2 }}</span>
				</div>
			</form>
		</div>
		<div class="payment-container">
			<span>选择支付方式</span>
			<div v-for="item in paymentMethods" :key="item.value" class="payment-method"
				:class="{ active: selectedMethod === item.value }" @click="selectMethod(item.value,item.id)">
				<input type="radio" :id="item.value" :value="item.value" v-model="selectedMethod" hidden>
				<img :src="item.icon" class="method-icon">
				<label :for="item.value">{{ item.label }}</label>
			</div>
		</div>
		<button class="confirm-btn" @click="handlePayment">立即支付</button>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	export default {
		data() {
			return {
				type: 0,
				title: '',
				topText: '',
				text1: '',
				text2: '',
				money: 0,
				titleMap: {
					0: '获取提现名额',
					// 1: '开通大额提现',
					2: '开通微信钱包',
					3: '开通支付宝钱包',
					4: '获取银行卡解冻名额',
					5: '获取亏损资金追回名额',
					6: '缴纳个人所得税',
					7: '成为VIP会员',
					8: '开通网银',
					9: '解除限额',
				},
				topTextMap: {
					0: '获取名额，提现秒到账',
					// 1: '',
					2: '开通钱包，提现秒到账',
					3: '开通钱包，提现秒到账',
					4: '获取名额，解冻银行卡',
					5: '获取名额，追回亏损资金',
					6: '为国聚财，为民收税',
					7: 'VIP会员，专属服务',
					8: '开通网银，实时汇款到账',
					9: '办理业务，解除限额',
				},
				text1Map: {
					0: '获得名额即可获得国家开发银行提现的资格',
					// 1: '',
					2: '开通微信钱包后即可绑定微信',
					3: '开通微信钱包后即可绑定支付宝',
					4: '获取银行卡解冻名额',
					5: '获取亏损资金追回名额',
					6: '依法纳税是每位公民应尽的义务',
					7: '成为国家开发银行VIP会员',
					8: '开通网银后即可享受',
					9: '账户因汇款交易异常已暂停服务',
				},
				text2Map: {
					0: '否则将视为自动放弃提现的资格！',
					// 1: '',
					2: '享受直接提现到账微信',
					3: '享受直接提现到账支付宝',
					4: '即可解冻银行卡',
					5: '即可追回亏损资金',
					6: '诚信纳税靠大家！',
					7: '享受会员制VIP绿色通道服务',
					8: '国家开发银行实时汇款到账服务',
					9: '办理成功后交易解除汇款限额',
				},
				typeMap: {
					0: '获取提现名额',
					2: '开通微信钱包',
					3: '开通支付宝钱包',
					4: '解冻银行卡',
					5: '亏损资金追回',
					6: '缴纳个人所得税',
					7: '成为VIP会员',
					8: '开通网银',
					9: '解除限额',
				},
				moneyMap: {},
				data: {},
				selectedMethod: '',
				paymentMethods: [{
						value: '8010',
						id: '2',
						label: '支付宝支付',
						icon: require('../images/user/payzfb.png')
					},
					{
						value: '8009',
						id: '3',
						label: '微信支付',
						icon: require('../images/user/paywx.png')
					},
					{
						value: '8011',
						id: '4',
						label: '云闪付支付',
						icon: require('../images/user/payysf.png')
					}
				]
			}
		},
		created() {
			this.$parent.footer('user', false);
			this.type = Number(this.$route.query.type) || 0;
			this.title = this.titleMap[this.type] || this.titleMap[0];
			this.topText = this.topTextMap[this.type] || this.topTextMap[0];
			this.text1 = this.text1Map[this.type] || this.text1Map[0];
			this.text2 = this.text2Map[this.type] || this.text2Map[0];
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
					this.moneyMap[0] = r.data.paymentAmount;
					this.moneyMap[2] = r.data.wx_paymentAmount;
					this.moneyMap[3] = r.data.zfb_paymentAmount;
					this.moneyMap[4] = r.data.thaw_paymentAmount;
					this.moneyMap[5] = r.data.recover_paymentAmount;
					this.moneyMap[6] = r.data.paytaxes_paymentAmount;
					this.moneyMap[7] = r.data.fivestars_paymentAmount;
					this.moneyMap[8] = r.data.onlineBank_paymentAmount;
					this.moneyMap[9] = r.data.liftLimit_paymentAmount;
					this.money = this.moneyMap[this.type] || this.moneyMap[0];
				});
			},
			selectMethod(item, id) {
				this.selectedMethod = item
				this.id = id
			},
			handlePayment() {
				if (!this.selectedMethod) {
					this.$toast({
						className: "toastName",
						message: '请选择支付方式',
					});
					return false;
				}
				const productId = this.selectedMethod;
				const money = this.money;
				const id = this.id;
				const type = this.typeMap[this.type];
				Fetch('/user/recharge_type', {
					productId,
					money,
					id,
					type
				}).then(res => {
					window.location.href = res.data.payUrl;
					// window.open(res.data.payUrl, '_blank');
					this.$toast({
						className: "toastName",
						message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
					});
				}).catch(error => {
					this.$toast({
						className: "toastName",
						message: '操作失败，请联系客服',
					});
				});
			},
		}
	}
</script>

<style lang="less" scoped>
	.page-container {
		height: 800px;
		background: url(../images/user/redimg.jpg) no-repeat center;
		background-size: 112% 102%;
		position: relative;
		// height: 100vh;
	}

	.headers {
		color: #ffd08e;
		font-size: 24px;
		position: absolute;
		top: 10%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 100%;
		text-align: center;
	}

	.form-wrapper {
		position: absolute;
		top: 41%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 90%;
		max-width: 500px;
		background: #fff;
		padding: 0 20px 20px;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.card-form h2 {
		text-align: center;
		margin-bottom: 20px;
	}

	.form-title {
		width: 200px;
		margin: 0 auto 10px;
		background: #d7000f;
		color: #fff;
		border-radius: 0 0 12px 12px;
		padding: 8px 0;
		font-size: 16px;
		text-align: center;
		margin-bottom: 15px;
		font-weight: bold;
	}

	.form-money {
		width: 200px;
		margin: 0 auto 10px;
		color: #585858;
		font-size: 16px;
		text-align: center;
		margin-bottom: 15px;
		font-weight: bold;
	}

	.form-money span {
		color: #d7000f;
		font-size: 20px;
	}

	.form-group {
		margin-bottom: 20px;
		// display: flex;
		// justify-content: space-around;
		// align-items: center;
	}

	label {
		display: block;
		margin-bottom: 8px;
	}

	input {
		width: 100%;
		padding: 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
	}

	.preview img {
		max-width: 100%;
		max-height: 200px;
		margin-top: 10px;
	}

	.confirm-btn {
		position: absolute;
		bottom: 25px;
		width: 90%;
		max-width: 500px;
		left: 50%;
		transform: translateX(-50%);
		padding: 12px 40px;
		background: #ffdf9a;
		color: red;
		border: none;
		border-radius: 4px;
		font-size: 18px;
		font-weight: bold;
		cursor: pointer;
	}

	.confirm-text {
		font-weight: bold;
		text-align: center;
		display: flex;
		flex-direction: column;
		font-size: 15px;
		color: red;
	}

	.add-card {
		display: block;
		width: 100%;
		height: 150px;
		line-height: 150px;
		background: #fff0e0;
		color: #d7000f;
		border: 1px dashed #d7000f;
		border-radius: 6px;
		font-size: 15px;
		text-align: center;
		margin-bottom: 12px;
		cursor: pointer;
	}

	.tip {
		color: #d7000f;
		font-size: 12px;
		text-align: center;
		margin-top: 8px;
		margin-bottom: 10px;
	}

	.imggw {
		position: absolute;
		top: 18%;
		left: 50%;
		transform: translateX(-50%);
	}

	.payment-container {
		max-width: 500px;
		margin: 0 auto;
		position: absolute;
		top: 70%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 90%;
		background: #fff;
		padding: 20px;
		border-radius: 8px;
	}

	.payment-container span {
		color: #585858;
		font-size: 15px;
		font-weight: 600;
	}

	.payment-method {
		display: flex;
		align-items: center;
		padding: 15px;
		border: 1px solid #ddd;
		border-radius: 8px;
		margin-bottom: 10px;
		cursor: pointer;
		transition: all 0.3s;
	}

	.payment-method.active {
		border-color: #1989fa;
		background-color: #f5faff;
	}

	.payment-method:first-of-type {
		margin-top: 15px;
	}

	.method-icon {
		width: 30px;
		height: 30px;
		margin-right: 15px;
	}
</style>